var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 70,
    viewBox: "0 0 90 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 70,
    rx: 7,
    fill: "#E7E7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 27H35.6667H57",
    stroke: "#767676",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3307 27V45.6666C54.3307 46.3739 54.0498 47.0521 53.5497 47.5522C53.0496 48.0523 52.3713 48.3333 51.6641 48.3333H38.3307C37.6235 48.3333 36.9452 48.0523 36.4451 47.5522C35.945 47.0521 35.6641 46.3739 35.6641 45.6666V27M39.6641 27V24.3333C39.6641 23.626 39.945 22.9478 40.4451 22.4477C40.9452 21.9476 41.6235 21.6666 42.3307 21.6666H47.6641C48.3713 21.6666 49.0496 21.9476 49.5497 22.4477C50.0498 22.9478 50.3307 23.626 50.3307 24.3333V27",
    stroke: "#767676",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3359 33.6666V41.6666",
    stroke: "#767676",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6641 33.6666V41.6666",
    stroke: "#767676",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveBtn);
export default __webpack_public_path__ + "static/media/removeBtn.23c4d13c8eaf511ff45ad6f9e00c2506.svg";
export { ForwardRef as ReactComponent };